"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var isDisabled = props.isDisabled,
    isSelected = props.isSelected,
    _props$color = props.color,
    color = _props$color === void 0 ? 'basic' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$isSeparator = props.isSeparator,
    isSeparator = _props$isSeparator === void 0 ? false : _props$isSeparator;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    fontSizeProps = _useStylesUtils.fontSizeProps;
  var ccListItemStyle = (0, _react.useMemo)(function () {
    var colorProps = function colorProps() {
      var borderColor = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border : 'transparent';
      var marginBlockStart = color === 'primary' ? pxToRem(12) : pxToRem(2);
      var padding = color === 'primary' ? "".concat(pxToRem(8), " ").concat(pxToRem(12)) : "".concat(pxToRem(4), " ").concat(pxToRem(12));
      return {
        borderColor: borderColor,
        marginBlockStart: marginBlockStart,
        padding: padding
      };
    };
    var hoverOrSelectedColorProps = function hoverOrSelectedColorProps() {
      var background = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light : themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main;
      var borderColor = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : 'transparent';
      var textColor = color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text;
      return {
        background: background,
        borderColor: borderColor,
        color: textColor
      };
    };
    var hoverColorProps = function hoverColorProps() {
      if (isDisabled || isSeparator) {
        return {};
      }
      return _objectSpread({}, hoverOrSelectedColorProps());
    };
    var selectedColorProps = function selectedColorProps() {
      if (isSelected) {
        return _objectSpread({}, hoverOrSelectedColorProps());
      }
      return {};
    };
    var disabledProps = function disabledProps() {
      if (isDisabled) {
        return {
          opacity: '.5',
          cursor: 'default'
        };
      }
      return {};
    };
    var separatorProps = function separatorProps() {
      if (isSeparator) {
        return {
          pointerEvents: 'none',
          cursor: 'inherit',
          color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
          whiteSpace: 'nowrap',
          gap: pxToRem(8),
          paddingInline: pxToRem(4),
          '&:after': {
            content: "''",
            height: pxToRem(2),
            width: '100%',
            backgroundColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border
          }
        };
      }
      return {};
    };
    var ccListItem = (0, _css.css)(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: pxToRem(5),
      cursor: 'pointer',
      border: '1px solid transparent',
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text
    }, fontSizeProps(size)), colorProps()), selectedColorProps()), disabledProps()), separatorProps()), {}, {
      '&:hover': _objectSpread({}, hoverColorProps()),
      '&:first-child': {
        marginBlockStart: 0
      }
    }));
    return ccListItem;
  }, [pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main, fontSizeProps, size, color, isDisabled, isSeparator, isSelected]);
  return {
    'cc-ListItem': ccListItemStyle
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;